var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AutomateVx {
    constructor(log) {
        this.apiToken = '314159';
        this.autoSwitch = false;
        this.currentLayout = 'A';
        this.currentRoomConfig = '1';
        this.cameras = [];
        this.layouts = [];
        this.roomConfigs = [];
        this.power = false;
        this.layoutIndex = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        this.asyncHandlers = [
            {
                name: 'autoSwitchStatus',
                path: /:\d+\/api\/(AutoSwitchStatus)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        status: 'OK',
                        results: this.autoSwitch,
                        message: `${this.autoSwitch ? '' : 'No '}AutoSwitching in Progress`,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'autoSwitchStartStop',
                path: /:\d+\/api\/(StartAutoSwitch|StopAutoSwitch)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    this.autoSwitch = match[1].toLowerCase() === 'startautoswitch';
                    const response = {
                        status: 'OK',
                        message: `AutoSwitching ${this.autoSwitch ? 'Started' : 'Stopped'} Successfully`,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'camerasGet',
                path: /:\d+\/api\/GetCameras/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        status: 'OK',
                        message: 'cameras loaded successfully',
                        cameras: this.cameras,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'cameraPresetRecall',
                path: /:\d+\/api\/CallCameraPreset/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d;
                    const preset = (_b = (_a = req === null || req === void 0 ? void 0 : req.data) === null || _a === void 0 ? void 0 : _a.pre) !== null && _b !== void 0 ? _b : '1';
                    const camera = (_d = (_c = req === null || req === void 0 ? void 0 : req.data) === null || _c === void 0 ? void 0 : _c.cam) !== null && _d !== void 0 ? _d : '1';
                    const response = {
                        status: 'OK',
                        message: `Successfully called preset ${preset} for camera ${camera}`,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'getToken',
                path: /:\d+\/Get-Token/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        status: 'OK',
                        token: this.apiToken,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'layoutChange',
                path: /:\d+\/api\/ChangeLayout/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _e, _f;
                    this.currentLayout = (_f = (_e = req === null || req === void 0 ? void 0 : req.data) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : 'A';
                    const response = {
                        status: 'OK',
                        message: `Changed to Layout ${this.currentLayout}`,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'layoutGet',
                path: /:\d+\/api\/GetLayouts/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        status: 'OK',
                        message: 'Layouts loaded successfully',
                        layouts: this.layouts,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'layoutStatus',
                path: /:\d+\/api\/LayoutStatus/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const layoutIndex = this.layoutIndex.indexOf(this.currentLayout);
                    const layout = this.layouts[layoutIndex];
                    const layoutName = (layout === null || layout === void 0 ? void 0 : layout.name) ? layout.name : 'Default Name';
                    const response = {
                        status: 'OK',
                        message: 'Current layout queried successfully',
                        layout: {
                            id: this.currentLayout,
                            name: layoutName,
                        },
                    };
                    return { data: response };
                }),
            },
            {
                name: 'manualSwitchCamera',
                path: /:\d+\/api\/ManualSwitchCamera/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _g;
                    const manualCamera = (_g = req === null || req === void 0 ? void 0 : req.data) === null || _g === void 0 ? void 0 : _g.address;
                    console.log(`emulator : manual camera is ${manualCamera}`);
                    const response = {
                        status: 'OK',
                        message: `Successfully switched shot to ${manualCamera}`,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'power',
                path: /:\d+\/api\/(Wake|Sleep)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    this.power = match[1].toLowerCase() === 'wake';
                    const response = {
                        status: 'OK',
                        message: `VX ${this.power ? 'woke up' : 'went to sleep'} successfully`,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'roomConfigChange',
                path: /:\d+\/api\/ChangeRoomConfig/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _h, _j;
                    const configId = (_j = (_h = req === null || req === void 0 ? void 0 : req.data) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : '1';
                    const message = configId === this.currentRoomConfig
                        ? `Already on Room Configuration ${configId}`
                        : `Changed to Room Configuration ${configId}`;
                    this.currentRoomConfig = configId;
                    const response = {
                        status: 'OK',
                        message: message,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'roomConfigsGet',
                path: /:\d+\/api\/GetRoomConfigs/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        status: 'OK',
                        message: 'Room configs loaded successfully',
                        layouts: this.roomConfigs,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'roomConfigStatus',
                path: /:\d+\/api\/RoomConfigStatus/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const configIndex = parseInt(this.currentRoomConfig, 10) - 1;
                    const roomConfig = this.roomConfigs[configIndex];
                    const configName = roomConfig ? roomConfig.name : 'Default Name';
                    const response = {
                        status: 'OK',
                        message: 'Current room configuration queried successfully',
                        layout: [
                            {
                                id: this.currentRoomConfig,
                                name: configName,
                            },
                        ],
                    };
                    return { data: response };
                }),
            },
            {
                name: 'startPT',
                path: /:\d+\/api\/(StartPT|StopPT)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _k, _l;
                    const cameraId = (_l = (_k = req === null || req === void 0 ? void 0 : req.data) === null || _k === void 0 ? void 0 : _k.cam) !== null && _l !== void 0 ? _l : '1';
                    const started = match[1].toLowerCase() === 'startpt';
                    const response = {
                        status: 'OK',
                        message: `Successfully ${started ? 'called started movement' : 'called stop'} for camera ${cameraId}`,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'startZ',
                path: /:\d+\/api\/(StartZ|StopZ)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _m, _o;
                    const cameraId = (_o = (_m = req === null || req === void 0 ? void 0 : req.data) === null || _m === void 0 ? void 0 : _m.cam) !== null && _o !== void 0 ? _o : '1';
                    const started = match[1].toLowerCase() === 'startz';
                    const response = {
                        status: 'OK',
                        // API guide indicates the start message is 'TBD'.
                        message: `Successfully ${started ? 'called started movement' : 'called stop'} camera ${cameraId}`,
                    };
                    return { data: response };
                }),
            },
            {
                path: /.+/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        status: 'Error',
                        err: 'Unknown command',
                    };
                    return { data: response };
                }),
            },
        ];
        for (let i = 1; i <= 3; i++) {
            this.cameras.push({
                id: i,
                model: 'AutomateVX Camera',
                ip: `192.168.100.${i}`,
            });
        }
        for (let i = 1; i < 5; i++) {
            this.layouts.push({
                id: this.layoutIndex[i - 1],
                name: `Layout ${this.layoutIndex[i - 1]}`,
            });
        }
        for (let i = 1; i < 4; i++) {
            this.roomConfigs.push({
                id: `${i}`,
                name: `Room Config ${i}`,
            });
        }
    }
}
AutomateVx.emulatorType = 'httpRequestEmulator';
AutomateVx.key = '-NQV8kNRGYQ12DTC9d0p';
